import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";
/**** EC-421 - PLP ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
sortSelectStyles.select = {
    cssOverrides: {
        formField: css`
            width: 325px;
            span[class^="IconWrapper"]{
                background: ${WhitecapColors.white};
            }
        `,
    },
    labelProps: {
        css: css`
            min-height: 22px;
            display: inline-block;
            text-align: right;
            padding: 9px 15px 0px 0px;
            width: unset;
            font-size: 15px;
            font-weight: 600;
            
        `,
    },
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
